module.exports = __webpack_public_path__ + "2365d5219b2a0a0bbfd2ca55397f8b5c.pdf";